import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { Expander } from "@models/configurators/expander";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IAccordion } from "@models/entity-models";

@Kbo(CToken.Accordion)
export class Accordion extends UiObject implements IAccordion {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    private _expanders: Expander[];
    @Enumerable()
    public get expanders(): Expander[] {
        if (!this._expanders) this._expanders = [];
        return this._expanders;
    }
    public set expanders(val) {
        this._expanders = val;
    }

    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return this.filterChildren<T>(tokens,
            this.expanders
        );
    }

    public allowedChildren(rootType: CToken): CToken[] {
        return [
            CToken.Expander
        ];
    }
}

